import {
  AppWindow,
  Bell,
  Bookmark,
  Calendar,
  FileSearch,
  FileText,
  LayoutTemplate,
  Mail,
  MessagesSquare,
  Route,
  Sparkles,
  User,
} from 'lucide-react';
import type { ChatActivityIcon } from '@wundo/shared/chat.ts';
import { PracticeIcon } from '../icons/practice-icon.tsx';

type Glyph = typeof Calendar | typeof PracticeIcon;

const GLYPHS: Record<ChatActivityIcon, Glyph> = {
  calendar: Calendar,
  search: FileSearch,
  person: User,
  memory: Bookmark,
  mail: Mail,
  reminder: Bell,
  document: FileText,
  template: LayoutTemplate,
  practice: PracticeIcon,
  conversation: MessagesSquare,
  journey: Route,
  page: AppWindow,
};

export interface ChatActivityIconGlyphProps {
  /** A key the app does not know yet (a newer server) falls back to a neutral mark. */
  icon?: ChatActivityIcon;
}

/** The picture beside a step: what kind of thing the step touches. */
export function ChatActivityIconGlyph({ icon }: ChatActivityIconGlyphProps) {
  const Glyph =
    icon !== undefined && Object.hasOwn(GLYPHS, icon) ? GLYPHS[icon] : Sparkles;

  return <Glyph size={13} aria-hidden='true' className='shrink-0' />;
}
